import { render, staticRenderFns } from "./NewMessengerTickets.vue?vue&type=template&id=60f00f87&scoped=true"
import script from "./NewMessengerTickets.vue?vue&type=script&lang=js"
export * from "./NewMessengerTickets.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerTickets.vue?vue&type=style&index=0&id=60f00f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f00f87",
  null
  
)

export default component.exports